(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('workspace', workspaceService);

    workspaceService.$inject = ['$log', '_', "eventService", 'utils', 'guard', 'muSettings'];

    function workspaceService($log, _, eventService, utils, guard, settings) {
        var workspace = {
            products: [],
            materials: [],
            settings: settings,

            addProduct: addProduct,
            insertProduct: insertProduct,
            removeProductById: removeProductById,
            getProductById: getProductById,
            getProductIndexById: getProductIndexById,

            getMaterialColourById: getMaterialColourById
        };

        return workspace;

        // -------------------------------------------------------------------------------------

        function addProduct(newProduct) {
            workspace.products.push(newProduct);
        }

        function insertProduct(newProduct, index) {
            utils.array.insert(workspace.products, index, newProduct);
        }

        function removeProductById(productId) {
            var product = getProductById(productId);
            if (product) {
                removeProduct(product);
            }
        }

        function removeProduct(product) {
            utils.array.remove(workspace.products, product);
        }

        function getProductById(productId) {
            return _.find(workspace.products, function (product) {
                return product.id === productId;
            });
        }

        function getProductIndexById(productId) {
            return _.findIndex(workspace.products, function (product) {
                return product.id === productId;
            });
        }

        function getMaterialColourById(materialId, colourId) {
            var material = _.find(workspace.materials, function (material) {
                return material.id === materialId;
            });

            if (angular.isUndefined(material)) {
                return null;
            }

            var colour = _.find(material.colours, function (colour) {
                return colour.id === colourId;
            });

            if (angular.isUndefined(colour)) {
                return null;
            }

            return {
                material: material,
                colour: colour
            };
        }
    }
}());